/** Shared types/helpers for HiveDesk timesheet XLSX import (upload-summary + rate import). */

export type TimesheetSessionRow = {
  rowNumber?: number;
  task?: string | null;
  workSessionType?: string | null;
  dateStart?: string | null;
  dateEnd?: string | null;
  timeStart?: string | null;
  timeEnd?: string | null;
  loggedTime: string;
  activeTime: string;
  loggedSeconds?: number;
  activeSeconds?: number;
  activityPct: number;
  cost: number;
};

export type TimesheetProjectRow = {
  project: string;
  workSessionType: string | null;
  loggedTime: string;
  activeTime: string;
  activityPct: number;
  cost: number;
  sessionCount?: number;
  sessions?: TimesheetSessionRow[];
};

export type TimesheetReportMeta = {
  title?: string;
  sheetName?: string | null;
  dateRange?: { raw: string; from?: string; to?: string };
  timezone?: string;
};

export type TimesheetUploadSummaryResponse = {
  report?: TimesheetReportMeta;
  employees?: Array<{
    name: string;
    hourlyRate: number | null;
    projects: TimesheetProjectRow[];
    totals: {
      loggedTime: string;
      activeTime: string;
      activityPct: number;
      cost: number;
      sessionCount?: number;
    };
  }>;
  summary?: {
    totalEmployees: number;
    loggedTime: string;
    activeTime: string;
    activityPct: number;
    cost: number;
  };
  meta?: {
    fileName: string;
    rows: number;
    parsedRows: number;
    invalidRows: number;
  };
  invalid?: Array<{ rowNumber: number; error: string; raw: Record<string, unknown> }>;
};

/** contoh nama file: timesheet-report-2026-01-25-2026-02-24.xlsx */
export function extractDateRangeFromFilename(fileName: string | null | undefined): { start: string; end: string } | null {
  const s = String(fileName ?? "").trim();
  if (!s) return null;
  const m = s.match(/(\d{4}-\d{2}-\d{2})-(\d{4}-\d{2}-\d{2})/);
  if (!m) return null;
  return { start: m[1], end: m[2] };
}

export function sameYmd(a: string | null | undefined, b: string | null | undefined): boolean {
  return String(a ?? "").trim() === String(b ?? "").trim();
}
